import Vue from 'vue'
/* eslint-disable */
/**
 * 校验中英文姓名
 * @param rule
 * @param value
 * @param callback
 * @returns {*}
 */
export const validChineseEng = (rule, value, callback) => {
  var regu = "^[a-zA-Z\u4e00-\u9fa5]+$";
  var re = new RegExp(regu);
  if(Vue.prototype.$myplug.isEmpty(value)) {
    return callback(new Error('请输入'));
  }else{
    if(value.search(re) == -1){
      return callback(new Error('仅限字母和汉字'));
    }else{
      callback();
    }
  }
};
export const validTel = (rule, value, callback) => {
  const reg = /^1\d{10}$/g
  const zj= /^(?:(?:\d{3}-)?\d{8}|^(?:\d{4}-)?\d{7,8})(?:-\d+)?$/ //座机
  // if(Vue.prototype.$myplug.isEmpty(value)) {
  //   return callback(new Error('请输入'));
  // }else{
  //   console.log('是否')

    if(!reg.test(value)&&!(zj.test(value))){
      return callback(new Error('请输入正确的电话号码'));
    }else{
      callback();
    }
  // }
};
export const validVal = (rule, value, callback) => {
  if(Vue.prototype.$myplug.isEmpty(value)) {
    return callback(new Error('请输入'));
  }else{
    callback();
  }
};

export const jstValidPhone = (rule, value, callback) => {
    const reg= /[^0-9()-]/
    if(reg.test(value)||value.length>15){
      return callback(new Error('请输入正确的电话号码'));
    }else{
      callback();
    }
  // }
};

export const validSel = (rule, value, callback) => {
  if(!value && value !== 0) {
    return callback(new Error('请选择'));
  }
  callback();
};

export const validCasader = (rule, value, callback) => {
  if(value.length == 0) {
    return callback(new Error('请选择'));
  }else{
    callback();
  }
};

export const validNum = (rule, value, callback) => {
  if(!Vue.prototype.$myplug.isNumber(value)) {
    return callback(new Error('请输入数字'));
  }
  callback();
};

export const validSize = (rule, value, callback) => {
  if(Vue.prototype.$myplug.transNumber(value) < 0 || Vue.prototype.$myplug.transNumber(value) > 100) {
    return callback(new Error('请输入 0-100 之间的数字'));
  }
  callback();
};

export const validFloat = (rule, value, callback) => {
  if(Vue.prototype.$myplug.cutSplit(value, '.').length == 2 && (Vue.prototype.$myplug.cutSplit(value, '.')[1]).length > 2) {
    return callback(new Error('请保留两位小数'));
  }
  callback();
};

export const validLength = (rule, value, callback, val) => {
  if(value) {
    if(value.length > val) {
      return callback(new Error('输入内容不能超过' + val + '个字'));
    }else{
      callback();
    }
  }else{
    callback();
  }
};

export const validPhone = (rule, value, callback) => {
  if(value) {
    if(!/^((0\d{2,3}-)?\d{7,8})|(1[3-9]\d{9})$/.test(value) ) {
      return callback(new Error('请输入正确的电话号码或手机号码'));
    }
  }
  callback();
};
export const validCompPhone = (rule, value, callback) => {
  if(value) {
    //if(!/^((0\d{2,3}-)?\d{7,8})|(1[3-9]\d{9})$/.test(value) ) {
    if(!( /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(value) || /^0?1[3|4|5|8][0-9]\d{8}$/.test(value) ||  /^[0-9]{5}$/.test(value))) {
      return callback(new Error('请输入正确的电话号码或手机号码'));
    }
  }
  callback();
};

export const validZmdxSz = (rule, value, callback) => {
  if(value) {
    if(!/^[A-Z0-9]*$/.test(value)) {
      return callback(new Error('限字母（大写）加数字'));
    }else{
      callback();
    }
  }else{
    callback();
  }

};

export const validInput = (rule, value, callback, type) => {
  if(type === true) {
    if(!value) {
      return callback(new Error('请输入'));
    }
  }
  callback();
};

export const validOptions = (rule, value, callback, type) => {
  if(type === true) {
    if(!value) {
      return callback(new Error('请选择'));
    }
  }
  callback();
};
export const testChinese = (value) =>{
  const regxC=/[\u4e00-\u9fa5]/g;
  const regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im,
    regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im,
    regEng=/([A-Z]{1}[a-z])/g;
  let flag=true;
  if(!regEn.test(value) || !regCn.test(value)){
    if(regxC.test(value) && value.length > 1 || regEng.test(value) && value.length>3 ){
      flag=true;
    }else{
      flag=false
    }
  }else{
    flag=false
  }

  return flag;
}
export const validNullEmpty = (rule, value, callback) => {
  if(Vue.prototype.$myplug.isEmpty(value)) {
    return callback(new Error('请输入'));
  }
  callback();
};
export const validNameLength = (rule, value, callback) => {
  if(!value){
    return callback(new Error('请输入'));
  }else{
    if(value.length > 20){
      return callback(new Error('仅限20个字符'));
    }else{
      callback();
    }
  }
};
export const isvalidUsername = (str) =>{
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

/* 合法uri*/
export const validateURL = (textval) =>{
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlregex.test(textval)
}

/* 小写字母*/
export const validateLowerCase= (str) => {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母*/
export const validateUpperCase= (str)=> {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母*/
export const validatAlphabets= (str)=> {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}
/**
 * 判断是否为空
 */
export const validatenull=(val)=> {
  if (typeof val === 'boolean') {
    return false
  }
  if (val instanceof Array) {
    if (val.length === 0) return true
  } else if (val instanceof Object) {
    if (JSON.stringify(val) === '{}') return true
  } else {
    if (val === 'null' || val == null || val === 'undefined' || val === undefined || val === '') return true
    return false
  }
  return false
}

/**
 * 判断手机号码是否正确
 */
export const isvalidatemobile=(phone)=>  {
  const list = []
  let result = true
  let msg = ''
  var isPhone = /^0\d{2,3}-?\d{7,8}$/
  // 增加134 减少|1349[0-9]{7}，增加181,增加145，增加17[678]
  // const isMob = /^((\+?86)|(\(\+86\)))?(13[0123456789][0-9]{8}|15[012356789][0-9]{8}|18[012356789][0-9]{8}|14[57][0-9]{8}|17[3678][0-9]{8})$/
  if (!validatenull(phone)) {
    if (phone.length === 11) {
      if (isPhone.test(phone)) {
        msg = '手机号码格式不正确'
      } else {
        result = false
      }
    } else {
      msg = '手机号码长度不为11位'
    }
  } else {
    msg = '手机号码不能为空'
  }
  list.push(result)
  list.push(msg)
  return list
}
/*数字校验*/
// export const validNum=(val,num)=> {
//   var reg = /^\d{num}$/;
//   return reg.test(val);
// }
